import { useContext, useEffect, useState } from "react"
import { MitStorage } from "./MitStorage"
import { PersistenceObjectType, PersistenceScope, SessionContext, SettingsManager, ViamapPersistenceLayer } from "@viamap/viamap2-common"
import { ActionTracker } from "src/common/managers/ActionTracker"

export function useMitPersistenceState(key: string, defaultValue: any) {
   const { state } = useContext(SessionContext)
   const [value, setState] = useState(MitStorage.getValue(key) ?? defaultValue)

   function setValue(newValue: any) {
      setState(newValue)
      MitStorage.setValue(key, newValue)

      let persist = new ViamapPersistenceLayer(SettingsManager.getSystemSetting("viamapStoreS3Bucket"))
      persist.uploadObject(PersistenceScope.User, PersistenceObjectType.Settings, state.customerRef, state.userRef, JSON.stringify(newValue, MitStorage.replacer), key + ".json").catch((err) => {
         ActionTracker.track("Error", "Caught error", "useMitPersistenceState - setValue", {
            ErrorLocation: "MPS key: " + key || undefined,
            ErrorMessage: JSON.stringify(err),
         })
      });
   }

   useEffect(() => {
      const abort = new AbortController()
      let persist = new ViamapPersistenceLayer(SettingsManager.getSystemSetting("viamapStoreS3Bucket"))
      persist.getObject(PersistenceScope.User, PersistenceObjectType.Settings, state.customerRef, state.userRef, key + ".json").then((res) => {
         if (abort.signal.aborted) return
         let str = res.Body.toString()
         setState(JSON.parse(str, MitStorage.reviver))
      }).catch((err) => {
         // Status code 404 : NoSuchKey
         if ("statusCode" in err && err.statusCode === 404) return
         ActionTracker.track("Error", "Caught error", "useMitPersistenceState - getValue", {
            ErrorLocation: "MPS key: " + key || undefined,
            ErrorMessage: JSON.stringify(err),
         })
      });
      return () => abort.abort()
   }, [key])

   return [value, setValue] as const
}

